import IconButton from '@mui/material/IconButton';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { BottomNavigation } from '@/components';
import { Button } from '@mui/material';
import flyerNotFound from '@/assets/flyer_not_found.png';
import styles from './FlyerDetailsRemoved.styles';

interface Props {
  goToPreviousPage: () => void;
  goToExploreFlyers: () => void;
}

export const FlyerDetailsRemoved: React.FC<Props> = ({
  goToPreviousPage,
  goToExploreFlyers,
}) => (
  <div className={styles.flyerRemovedPage}>
    <div className={styles.header}>
      <IconButton onClick={goToPreviousPage} aria-label="Back button">
        <CloseOutlinedIcon />
      </IconButton>
    </div>
    <div className={styles.flyerRemovedContainer}>
      <img
        src={flyerNotFound}
        width="328px"
        height="420px"
        alt="This flyer can not be found"
      />
      <div className={styles.flyerRemovedButton}>
        <Button
          variant="contained"
          color="secondary"
          onClick={goToExploreFlyers}
        >
          Go to Explore Page
        </Button>
      </div>
    </div>
    <div className={styles.flyerRemovedBottom}>
      <BottomNavigation />
    </div>
  </div>
);

